module.exports = __webpack_public_path__ + "static/media/punch.78add758.png";